import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import MatchListLayer from "../../components/MatchDiscoveryControl/MatchListLayer";

const MatchList = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Match Users" />
        <MatchListLayer />
      </MasterLayout>
    </>
  );
};

export default MatchList;
